import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyBppBeBG5kgL_js2sgOILpMmAmkb1bbzoM',
  authDomain: 'chapappqa2.firebaseapp.com',
  databaseURL: 'https://chapappqa2-default-rtdb.firebaseio.com',
  projectId: 'chapappqa2',
  storageBucket: 'chapappqa2.appspot.com',
  messagingSenderId: '37118268178',
  appId: '1:37118268178:web:1b3f79d9d6e2a7f92b59cb',
  measurementId: 'G-PX7GB0YRD4'
};

firebase.initializeApp(firebaseConfig);
const db = firebase.database().ref();

export { firebase, db };
